import { Button, Dropdown, MenuProps, Tooltip } from 'antd';
import { FC, Fragment, ReactNode, useState } from 'react';
import { ThreeDotsVertical } from 'react-bootstrap-icons';

import { AppModalControlProps } from '@/common/interfaces';

import { PAGES_MASS_ACTIONS } from './Actions/pagesMassActions';

interface Props {
  siteId: string;
  disabled: boolean;
}

export const PagesMassActionsDropdownContainer: FC<Props> = ({ siteId, disabled }) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [activeModalKey, setActiveModalKey] = useState<string | null>(null);

  const buildControls = (key: string): AppModalControlProps => ({
    isOpen: activeModalKey === key,
    open: () => setActiveModalKey(key),
    close: () => setActiveModalKey((current) => (current === key ? null : current)),
  });

  const items: MenuProps['items'] = PAGES_MASS_ACTIONS.map((action) => ({
    key: action.key,
    icon: action.icon,
    label: action.label,
    danger: action.danger,
    onClick: () => setActiveModalKey(action.key),
    extra: action.extra && (
      <Tooltip title={action.extra.tooltip}>
        <Button
          type="default"
          size="small"
          icon={action.extra.icon}
          onClick={(e) => {
            e.stopPropagation();
            setDropdownOpen(false);
            setActiveModalKey(action.extra!.key);
          }}
        />
      </Tooltip>
    ),
  }));

  const modals: ReactNode[] = PAGES_MASS_ACTIONS.flatMap((action) => {
    const rendered: ReactNode[] = [
      <Fragment key={action.key}>{action.renderModal({ siteId, controls: buildControls(action.key) })}</Fragment>,
    ];

    if (action.extra) {
      rendered.push(
        <Fragment key={action.extra.key}>
          {action.extra.renderModal({ siteId, controls: buildControls(action.extra.key) })}
        </Fragment>,
      );
    }

    return rendered;
  });

  return (
    <>
      <Dropdown
        menu={{ items }}
        placement="bottomRight"
        trigger={['click']}
        disabled={disabled}
        open={dropdownOpen}
        onOpenChange={setDropdownOpen}
      >
        <Button icon={<ThreeDotsVertical />}>Дії над сторінками</Button>
      </Dropdown>

      {modals}
    </>
  );
};
